import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Modal from "react-modal";
import { formatDateTime } from "../common-data/Converts";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import LeadFollowupV1 from "../lead-management/followup/LeadFollowupV1";
import AddLeadForm from "../lead-management/AddLeadForm";
import {
  EyeIcon,
  CallIcon,
  XIcon,
  ExcludeIcon,
  PersonIcon,
} from "../../images/icons/icons";
import ViewDetails from "../odm/odm-details/ViewDetails";
import LeadJourney from "../lead-management/lms-v2/lead-journey/LeadJourney";
import ClickToCall from "../lead-management/lms-v2/lms-payment-links/ClickToCall";
import CommonTable from "../common-components/common-tables/CommonTable";

const ReferralListings = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  userInfoData,
  callFunction,
  prevFilters,
}) => {
  const { referralsLoading, referrals } = useSelector(
    (state) => state.prospects
  );

  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);
  const iniModvalues = {
    isModOpen: false,
    rowData: "",
    modName: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  function closeModal() {
    setModValues(iniModvalues);
  }

  useEffect(() => {
    if (referrals?.status && referrals?.data?.length > 0) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: referrals.data,
        pagination:
          referrals?.pagination?.length > 0 ? referrals.pagination : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [referrals]);

  const tbColumns = [
    {
      dataField: "lead_id",
      text: "Action",
      formatter: (_, row) => (
        <div className="pp-employee-payroll-actions">
          {row?.lead_id ? (
            <button
              key="view"
              type="button"
              className="pp-employee-payroll-action-button pp-outlined-border"
              onClick={() => {
                const modifiedRow = {
                  ...row,
                  name: row.referred_name,
                  mobile: row.referred_mobile,
                };

                delete modifiedRow.referred_name;
                delete modifiedRow.referred_mobile;

                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  rowData: modifiedRow,
                  modName: "view-lead-journey",
                }));
              }}
              disabled={!row?.lead_id}
            >
              {row?.lead_id ? <EyeIcon /> : <XIcon />}
              {row?.lead_id ? "View Lead" : "not added to LMS"}
            </button>
          ) : (
            <button
              key="add-to-lmd"
              type="button"
              className="pp-employee-payroll-action-button pp-outlined-border"
              onClick={() => {
                const modifiedRow = {
                  ...row,
                  name: row.referred_name,
                  mobile: row.referred_mobile,
                };

                delete modifiedRow.referred_name;
                delete modifiedRow.referred_mobile;

                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  rowData: modifiedRow,
                  modName: "add",
                }));
              }}
            >
              <ExcludeIcon />
              Add To LMS
            </button>
          )}

          <button
            key="click-to-call"
            type="button"
            className="pp-employee-payroll-action-button pp-outlined-border"
            onClick={() => {
              setModValues({
                isModOpen: true,
                modName: "click-to-call",
                rowData: row,
              });
            }}
          >
            <CallIcon color="#000" />
            click to call
          </button>
        </div>
      ),
    },
    {
      dataField: "added_by",
      text: "added by",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>
              <span className="tb-data">{row?.added_by_name || "NA"}</span>
            </div>

            {row?.added_by_mobile && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <CallIcon />
                </span>
                <span className="tb-data">{row.added_by_mobile || "NA"}</span>
              </div>
            )}

            {row?.account_type && (
              <span className="tb-data tb-badge tb-badge-success-1">
                {row?.account_type?.replace(/_/g, " ") || ""}
              </span>
            )}
          </div>
        );
      },
    },
    {
      dataField: "referrer_id",
      text: "referrer",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>
              <span className="tb-data">{row?.referrer_name || "NA"}</span>
            </div>

            {row?.referrer_mobile && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <CallIcon />
                </span>
                <span className="tb-data">{row.referrer_mobile || "NA"}</span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      dataField: "referrer_id",
      text: "referred",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>
              <span className="tb-data">{row?.referred_name || "NA"}</span>
            </div>

            {row?.referred_mobile && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <CallIcon />
                </span>
                <span className="tb-data">{row.referred_mobile || "NA"}</span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      dataField: "gym_id",
      text: "referrer	Gym Name",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.gym_name || "NA"}</span>;
      },
    },
    {
      dataField: "conversion_status",
      text: "conversion Status",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${row?.conversion_status ? "tb-badge" : ""} ${
              row?.conversion_status === "converted"
                ? "tb-badge-success"
                : row?.conversion_status === "pending"
                ? "tb-badge-success-1"
                : row?.conversion_status
                ? "not-assigned"
                : ""
            }`}
          >
            {row?.conversion_status?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "converted_date",
      text: "conversion date",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.converted_date ? formatDateTime(row.converted_date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "referral_date_added",
      text: "date added",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.referral_date_added
              ? formatDateTime(row.referral_date_added)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => {
        return (
          <div className="pp-employee-payroll-actions">
            <button
              key="view"
              type="button"
              className="pp-employee-payroll-action-button pp-outlined-border"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "view_details",
                  rowData: row,
                  from: "wati",
                }))
              }
            >
              <EyeIcon />
              view details
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={closeModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.modName === "view_details"
              ? "mod-width-50p mod-height-95vh view-detail-modal"
              : modValues.modName === "add"
              ? "p-0 mod-width-50p mod-height-95vh"
              : modValues.modName === "view-lead-journey"
              ? "mod-height-95vh mod-width-70p"
              : modValues.modName === "click-to-call"
              ? "mod-height-95vh mod-width-70p p-0 m-0 bg-white"
              : ""
          }`}
        >
          {modValues.modName === "add" ||
          modValues.modName === "click-to-call" ? null : (
            <ModalHeadAndClose
              title={
                modValues.modName === "view-lead-journey"
                  ? `Lead Details - ${
                      modValues.rowData?.user_name ||
                      modValues.rowData?.name ||
                      ""
                    }`
                  : `Lead Detail`
              }
              onClose={closeModal}
            />
          )}

          {modValues.modName === "view-lead-journey" ? (
            <LeadJourney
              userInfoData={userInfoData}
              rowData={modValues.rowData}
            />
          ) : modValues.modName === "follow-up" ? (
            <LeadFollowupV1
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              closeFollowupModal={closeModal}
              isReferral={true}
              // pageName="refferal"
              // prevFilters={prevFilters}
            />
          ) : modValues.modName === "add" ? (
            <AddLeadForm
              userInfoData={userInfoData}
              closeModal={closeModal}
              callFunction={callFunction}
              rowData={modValues.rowData}
              isUnassignedRawLead={true}
              clickedCard={"referral"}
            />
          ) : modValues.modName === "view_details" ? (
            <ViewDetails
              rowData={modValues.rowData}
              from={modValues.from}
              userInfoData={userInfoData}
              isTimeline={true}
            />
          ) : modValues.modName === "click-to-call" ? (
            <ClickToCall
              userInfoData={userInfoData}
              closeModal={closeModal}
              rowData={modValues.rowData}
            />
          ) : null}
        </div>
      </Modal>

      <div className="common-table-container tb-bordered mt15">
        <CommonTable
          tableData={allDatas.allData}
          tablePagination={allDatas.pagination}
          tableColumns={tbColumns}
          isPage={isPage}
          setIsPage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          isLoading={referralsLoading}
        />
      </div>

      {/* <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
        {referralsLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allDatas.allData}
            tableColumns={tbColumns}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            isFirstColSticky={true}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div> */}
    </>
  );
};

export default ReferralListings;
